import React, { Component, Fragment } from "react";
import { inject, observer } from 'mobx-react';
import classnames from "classnames";
import Avatar from "../../elements/avatar";
import { 
  Button, FormGroup, Input, Label, Table, DropdownMenu, DropdownItem, Media,
  UncontrolledDropdown, DropdownToggle, Modal, ModalBody, ModalHeader, ModalFooter 
} from "reactstrap";
import { Plus, Edit, Search, Trash, Tag, Check } from "react-feather";
import Select from "react-select";

import Checkbox from "../../../theme/@vuexy/checkbox/CheckboxesVuexy";
import profileImg from "../../../assets/img/profile/placeholder.svg";
import { navbarCollapse } from "../../../theme/reactstrap/navbar/NavbarSourceCode";

@inject('userSettingsStore')
@observer
class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      usersOverlayVisible: false,
      avatarEditVisible: false,
      isEditable: false,
      deleteModal: false
    };
  }

  componentDidMount = () => {
    const { userSettingsStore } = this.props;
    userSettingsStore.getUsers();
    userSettingsStore.getRoles();
  }


  onChange = event => {
    const { userSettingsStore } = this.props;
    let value = event.target.value;
    if(event.target.name === "roles") {
      //
    } else {
      userSettingsStore.setAttribute(event.target.name, value);
    }
    
  };

  onButtonToggle = event => {
    const { userSettingsStore } = this.props;
    let value = event.target.checked;
    if (event.target.name === "status") {
      userSettingsStore.setBooleanAttributes(event.target.name, value);
    }
  }

  handleSave = () => {
    const { userSettingsStore } = this.props;
    userSettingsStore.saveUser();
    this.toggleOverlay(false);
  }

  // toogle method will take 3 params -> toggle(required): bool, 'new'/'edit': string, data(set clicked item in props): any
  toggleOverlay = (toggle, action = "", data = false) => {
    const { userSettingsStore } = this.props;
    if (toggle) {
      if (action === "new") {
        userSettingsStore.setBlankUser();
      }
      if (action === "edit" && data) {
        userSettingsStore.setUser(data);
      }
    }
    this.setState({
      isEditable: action === "edit" ? true : false,
      usersOverlayVisible: toggle
    });
  }
  // Upload Avatar Slider
  toggleSlider = (bool) => {
    this.setState({
      avatarEditVisible: bool
    })
  }

  saveAvatar = (url) => {
    const { userSettingsStore } = this.props;
    userSettingsStore.setAvatar(url);
  }

  remove = (uid) => {
    this.setState({
      deleteModal: true,
      currentObjId: uid
    })
  }

  deleteEntry = () => {
    const { userSettingsStore } = this.props;
    userSettingsStore.deleteUser(this.state.currentObjId);
    this.setState({
      deleteModal: false
    })
  }

  handleChange = selectedOption => {
    console.log(selectedOption)
    const { userSettingsStore } = this.props;
    userSettingsStore.setRolesAttribute("roles", selectedOption);
  };

  render() {
    const { userSettingsStore } = this.props;
    const { users, userRoles } = userSettingsStore;
    let options = [];
    if (userRoles && userRoles.length) {
      options = userRoles.map((item) => {
        return ({
          label: item.name, 
          value: item.name,
        })
      })
    }
    const { 
      uid,
      title,
      firstName,
      lastName,
      status,
      image,
      lastLogin,
      role,
      roles,
      phone,
      email,
      password,
      createdOn
     } = userSettingsStore.user;
    return (
      <Fragment>
        <div className="topbar">
          <FormGroup className="position-relative mb-0" style={{ width: "30%" }}>
            <Input
              className="w-100 mr-1 mb-sm-0 search-product"
              type="text"
              placeholder="search..."
              value={this.state.searchVal}
            />
            <div className="form-control-position">
              <Search size={22} />
            </div>
          </FormGroup>
          <Button
            color="primary"
            className="btn"
            onClick={() => this.toggleOverlay(true, "new")}
          >
            <Plus size={18} />Add New
          </Button>
        </div>
        <div>
          {
            users && users.length
              ? <Table hover responsive>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Role</th>
                    <th>Status</th>
                    <th>Last Login</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    users.map((item, index) => {
                      return (
                        <tr key={item.uid}>
                          <td className=" d-flex align-items-center">
                            <div style={styles.imageDiv}>
                              <img style={styles.image} src={item.image ? item.image : profileImg} alt="Display Picture" />
                            </div>

                            {item.title}&nbsp;{item.firstName}&nbsp;{item.lastName}
                          </td>
                          <td>
                            {
                              item.roles && item.roles.length
                                ? item.roles.map((role, index)=>{
                                  return(
                                    <span>{role ? role : "-"}, </span>
                                  )
                                })
                              : null  
                            }
                          </td>
                          <td>{item.status ? "Active" : "Inactive"}</td>
                          <td>{item.lastLogin}</td>
                          <td className="text-center">
                            <Edit size={16} className="mr-1" onClick={() => this.toggleOverlay(true, 'edit', item)} />
                            <Trash size={16} color="#dc3545" onClick={ () => this.remove(item.uid) } />
                          </td>
                        </tr>
                      );
                    })
                  }
                </tbody>
              </Table> 
              : null
          }
        </div>
        <div className="animation-slider">
          {
            this.state.usersOverlayVisible
              ? <Fragment> 
                <div className="animation-slider-sidebar" style={{ width: "50vw" }}>
                  <div className="sidebar_header">
                    <span className="heading">
                      {this.state.isEditable ? "Update User" : "Add User"}
                    </span>
                    <div>
                      <Button
                        className="btn mr-1"
                        onClick={this.handleSave}
                        color="primary">
                         Save
                        </Button>
                      <Button
                        className="btn ml-1"
                        outline
                        color="danger"
                        onClick={()=>this.toggleOverlay(false)}
                      >
                        Cancel
                        </Button>
                    </div>
                  </div>
                  <div className="sidebar_content">
                    
                    <Media className="mb-2">
                      <Media className="mt-10 mr-2 my-25" left href="#">
                        <Media
                          className="rounded"
                          object
                          src={image ? image : profileImg}
                          alt="user profile image"
                          height="110"
                          width="95"
                        />
                      </Media>
                      <Media className="mt-2" body>
                        <Media className="font-medium-1 text-bold-600" tag="p" heading>
                          {/* {customer.account.title + " " + customer.account.firstName + " " + customer.account.lastName} */}
                        </Media>
                        <div className="d-flex flex-wrap">
                          <Button
                            onClick={() => { this.toggleSlider(true) }}
                            className="mr-50 cursor-pointer"
                            color="primary"
                            outline>
                            Change Avatar
                          </Button>
                          <Button color="flat-danger">Remove Avatar</Button>
                        </div>
                        <p className="text-muted mt-50">
                          <small>Allowed JPG, GIF or PNG. Max size of 800kB</small>
                        </p>
                      </Media>
                    </Media>

                    <FormGroup>
                      <Label htmlFor="user_title">Title</Label>
                      <Input
                        type="text"
                        value={title}
                        name="title"
                        placeholder="Title"
                        onChange={e => this.onChange(e)}
                        id="user_title"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label htmlFor="user_first_name">First Name</Label>
                      <Input
                        type="text"
                        value={firstName}
                        name="firstName"
                        placeholder="First Name"
                        onChange={e => this.onChange(e)}
                        id="user_first_name"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label htmlFor="user_last_name">Last Name</Label>
                      <Input
                        type="text"
                        value={lastName}
                        name="lastName"
                        placeholder="Last Name"
                        onChange={e => this.onChange(e)}
                        id="user_last_name"
                      />
                    </FormGroup>

                  <FormGroup>
                    <Label>Select Role</Label>
                      <Select
                        defaultValue={roles && roles.map(role => {
                          let index = options.findIndex((item) => item.label === role);
                          if (index > -1) {
                            return options[index]
                          }
                        })}
                        isMulti
                        name="colors"
                        options={options}
                        onChange={this.handleChange}
                        className="React"
                        classNamePrefix="select"
                      />
                  </FormGroup>

                    <FormGroup>
                      <Label htmlFor="phone">Contact No.</Label>
                      <Input
                        type="text"
                        value={phone}
                        name="phone"
                        placeholder="Contact No"
                        onChange={e => this.onChange(e)}
                        id="phone"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label htmlFor="email">Email</Label>
                      <Input
                        type="email"
                        value={email}
                        name="email"
                        placeholder="Email"
                        onChange={e => this.onChange(e)}
                        id="email"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label htmlFor="password">Password</Label>
                      <Input
                        type="password"
                        value={password}
                        name="password"
                        placeholder="Password"
                        onChange={e => this.onChange(e)}
                        id="password"
                      />
                    </FormGroup>
                    <FormGroup>
                      <div className="checkbox switcher">
                        <label htmlFor="status">
                          <input
                            type="checkbox"
                            id="status"
                            checked={status ? true : false}
                            name="status"
                            onChange={(e) => this.onButtonToggle(e)}
                            value={status} />
                          <span><small></small></span>
                          <span>Activate</span>
                        </label>
                      </div>
                    </FormGroup>
                  </div>
                </div>
                <div
                  className={classnames("animation-slider-overlay", {
                    show: this.state.usersOverlayVisible
                  })}
                  onClick={() => this.toggleOverlay(false)}
                />
              </Fragment>
              : null
          }
        </div>
        
        <Fragment>
          <div className="animation-slider">
            {
              this.state.avatarEditVisible
                ? <Avatar
                  width="50vw"
                  show={this.state.avatarEditVisible}
                  onSave={this.saveAvatar}
                  toggleSliderVisibility={() => this.toggleSlider(false)}
                />
                : null
            }
            <div
              className={classnames("animation-slider-overlay", {
                show: this.state.avatarEditVisible
              })}
              onClick={() => this.toggleSlider(false)}
            />
          </div>
          <Modal isOpen={this.state.deleteModal}>
            <ModalHeader>
              Delete Content
              </ModalHeader>
            <ModalBody>
              <h5>This action is permanent !</h5>
              <p> Are you sure you want to remove this user.</p>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={() => { this.setState({ deleteModal: false }) }}>Cancel</Button>{' '}
              <Button color="primary" onClick={this.deleteEntry}>Delete</Button>
            </ModalFooter>
          </Modal>
        </Fragment>

      </Fragment>
    );
  }
}

const styles = {
  imageDiv: {
    height: "38px",
    width: "38px",
    overflow: "hidden",
    borderRadius: "50%",
    marginRight: "1rem",
  },
  image: {
    height: "100%",
    width: "100%",
    objectFit: "contain",
    objectPosition: "center"
  }
}

export default Users;
